module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_local_browsing-61681ae697e701073fc648c4a5bc1343.svg";